<template>
    <row class="max-w-reading" dense>
        <column cols="12">
            <form-input v-model="data.current_password" name="current_password"
                        type="password"
                        :disabled="disabled"
                        :rules="{required: true}" :label="$t('input.user.current_password')"/>
        </column>
        <column cols="12">
            <form-input v-model="data.password" name="password"
                        type="password"
                        :disabled="disabled"
                        :help="$t('help.user.password')"
                        :rules="{required: true, min: 6, max: 100}" :label="$t('input.user.new_password')"/>
        </column>
        <column cols="12">
            <form-input v-model="data.password_confirmation" name="password_confirmation"
                        type="password"
                        :disabled="disabled"
                        :rules="{required: true, min: 6, max: 100, equal: data.password}" :label="$t('input.user.new_password_confirmation')"/>
        </column>
    </row>
</template>

<script>
import {FormInputsMixin} from "@spoferan/nuxt-spoferan/mixins";;

export default {

    name: 'UserPasswordDataFormInputs',

    mixins: [FormInputsMixin]
}
</script>